<app-admin-header></app-admin-header>
<div class="report-container">
  <app-admin-sidebar></app-admin-sidebar>
  <h2>📊 Drug Usage & Transfer Reports</h2>

  <div class="filters">
    <!-- Drug Dropdown -->
    <select [(ngModel)]="search.drug">
      <option value="">All Drugs</option>
      <option *ngFor="let drug of drugs" [value]="drug.name">{{ drug.name }}</option>
    </select>

    <!-- Store Dropdown -->
    <select [(ngModel)]="search.store">
      <option value="">All Stores</option>
      <option *ngFor="let store of stores" [value]="store.name">{{ store.name }}</option>
    </select>

    <!-- Patient Type -->
    <select [(ngModel)]="search.patientType">
      <option value="">All Patients</option>
      <option value="in-patient">In-Patients</option>
      <option value="out-patient">Out-Patients</option>
    </select>

    <!-- Date Filters -->
    <input type="date" [(ngModel)]="search.fromDate" />
    <input type="date" [(ngModel)]="search.toDate" />

    <button (click)="fetchReports()">Search</button>
  </div>

  <table class="report-table" *ngIf="reportData.length">
    <thead>
      <tr>
        <th>Drug</th>
        <th>Store</th>
        <th>Issued To</th>
        <th>Type</th>
        <th>Quantity</th>
        <th>Date</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of reportData">
        <td>{{ row.drug_name }}</td>
        <td>{{ row.store_name }}</td>
        <td>{{ row.recipient }}</td>
        <td>{{ row.recipient_type }}</td>
        <td>{{ row.quantity }}</td>
        <td>{{ row.date | date:'shortDate' }}</td>
      </tr>
    </tbody>
  </table>

  <p *ngIf="!reportData.length">No report data available for the selected filters.</p>
</div>
